import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home";
import Formulario from "./pages/formulario";
import NaoTenhoContrato from "./pages/naoTenhoContrato";
import ResultadoCalculo from "./pages/resultadoCalculo";
/* Administrativo */
import Login from "./area_administrativa/login/login.jsx";
import HomeAdm from "./area_administrativa/home/clientes.jsx";
import { AuthContext } from "./auth.jsx";
import { useContext } from "react";
import ReactPixel from "react-facebook-pixel";

const pixelId = "3748270498757068";

function RequireAuth({ children }) {
  const { logado } = useContext(AuthContext);
  return logado ? children : <Navigate to="/" />;
}

const pixelOptions = {
  autoConfig: true, // ativa o Pixel automaticamente
  debug: false, // coloque true se quiser ver logs no console
};

const App = () => {
  ReactPixel.init(pixelId, null, pixelOptions);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cadastro" element={<Formulario />} />
        <Route path="/naoTenhoContrato" element={<NaoTenhoContrato />} />
        <Route path="/resultadoCalculo" element={<ResultadoCalculo />} />
        <Route path="/admin" element={<Login />} />
        <Route
          path="/admin/home"
          element={
            <RequireAuth>
              <HomeAdm />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
